// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-connection-test {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.api-test-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.api-test-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.api-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
}

.status-connected {
  background: #d4edda;
  color: #155724;
}

.status-error {
  background: #f8d7da;
  color: #721c24;
}

.status-testing {
  background: #fff3cd;
  color: #856404;
}

.status-unknown {
  background: #e2e3e5;
  color: #383d41;
}

.status-icon {
  font-size: 1.1rem;
}

.api-test-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.test-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.test-btn:hover:not(:disabled) {
  background: #0056b3;
}

.test-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.last-test {
  color: #6c757d;
  font-size: 0.9rem;
}

.api-test-results {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.api-test-results h4 {
  margin: 0 0 12px 0;
  color: #1a1a1a;
  font-size: 1rem;
}

.error-result {
  background: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.success-results {
  margin-bottom: 12px;
}

.result-section {
  margin-bottom: 16px;
}

.result-section h5 {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 0.9rem;
}

.result-section pre {
  background: #e9ecef;
  padding: 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  overflow-x: auto;
  margin: 0;
}

.test-timestamp {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
}

.api-info {
  background: #e9ecef;
  border-radius: 8px;
  padding: 16px;
}

.api-info h4 {
  margin: 0 0 12px 0;
  color: #1a1a1a;
  font-size: 1rem;
}

.api-info p {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 0.9rem;
}

.api-info ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.api-info li {
  color: #495057;
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.api-info code {
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiConnectionTest.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB","sourcesContent":[".api-connection-test {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 24px;\n}\n\n.api-test-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.api-test-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.api-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.status-connected {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-error {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.status-testing {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-unknown {\n  background: #e2e3e5;\n  color: #383d41;\n}\n\n.status-icon {\n  font-size: 1.1rem;\n}\n\n.api-test-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.test-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.test-btn:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.test-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.last-test {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.api-test-results {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.api-test-results h4 {\n  margin: 0 0 12px 0;\n  color: #1a1a1a;\n  font-size: 1rem;\n}\n\n.error-result {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.success-results {\n  margin-bottom: 12px;\n}\n\n.result-section {\n  margin-bottom: 16px;\n}\n\n.result-section h5 {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.result-section pre {\n  background: #e9ecef;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  overflow-x: auto;\n  margin: 0;\n}\n\n.test-timestamp {\n  color: #6c757d;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n.api-info {\n  background: #e9ecef;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.api-info h4 {\n  margin: 0 0 12px 0;\n  color: #1a1a1a;\n  font-size: 1rem;\n}\n\n.api-info p {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.api-info ul {\n  margin: 8px 0 0 0;\n  padding-left: 20px;\n}\n\n.api-info li {\n  color: #495057;\n  font-size: 0.9rem;\n  margin-bottom: 4px;\n}\n\n.api-info code {\n  background: #f8f9fa;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
